import React, { useState } from 'react';
import DetailsTab from './CompanyDetails/CompanyDetails';
import BrandPersonality from './CompanyDetails/BrandPersonality';
import BrandKit from './CompanyDetails/BrandKit';
import Socials from './CompanyDetails/Socials';
import CustomerBase from './CustomerBase';
import OffersBenefits from './OffersBenefits';
import Competitors from './Competitors';
import Integration from './Integration';
import { updateCompany, getCompany } from '../../utils/api';
import "../../styles/CompanyManagement/CompanyManagement.css";



const TABS = [
  { label: 'Details', key: 'details' },
  { label: 'Brand Personality', key: 'brandPersonality' },
  { label: 'Brand Kit', key: 'brandKit' },
  { label: 'Socials', key: 'socials' },
  { label: 'Customer Base', key: 'customerBase' },
  { label: 'Offers & Benefits', key: 'offersBenefits' },
  { label: 'Competitors', key: 'competitors' },
  { label: 'Integration', key: 'integration' },
];

const initialState = {
  details: {},
  brandPersonality: {},
  brandKit: {},
  socials: {},
  customerBase: [],
  offersBenefits: [],
  competitors: [],
  integration: {},
};

export default function CompanyOnboarding({ onSuccess, onCompanyCreated }) {
  const [activeTab, setActiveTab] = useState(TABS[0].key);
  const [formData, setFormData] = useState(initialState);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const handleTabChange = (key) => setActiveTab(key);

  const handleSectionChange = (section, value) => {
    setFormData((prev) => ({ ...prev, [section]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError(null);
    try {
      // Prepare payload according to backend expectations
      const payload = {
        ...formData.details,
        additional_infos: {
          brandPersonality: formData.brandPersonality,
          brandKit: formData.brandKit,
          socials: formData.socials,
          customerBase: formData.customerBase,
          offersBenefits: formData.offersBenefits,
          competitors: formData.competitors,
          integration: formData.integration,
        },
      };
      // Check if company exists (by unique field, e.g. domain or name)
      let companyExists = false;
      if (payload.domain || payload.name) {
        try {
          const existing = await getCompany(payload.domain || payload.name);
          companyExists = !!existing;
        } catch (e) {
          companyExists = false;
        }
      }
      let createdId = null;
      if (companyExists) {
        const updated = await updateCompany(payload);
        createdId = updated?.id || null;
      } else {
        // fallback: POST to /api/v1/companies
        const res = await fetch('/api/v1/companies', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(payload),
        });
        if (res.ok) {
          const data = await res.json();
          createdId = data?.id;
        }
      }
      if (createdId && onCompanyCreated) onCompanyCreated(createdId);
      setLoading(false);
      if (onSuccess) onSuccess();
    } catch (err) {
      setError(err?.message || 'Failed to create/update company.');
      setLoading(false);
    }
  };

  return (
    <div className="company-onboarding">
      <h2>Onboard New Company</h2>
     
      <form onSubmit={handleSubmit}>
        <div className="tab-content">
          {activeTab === 'details' && (
            <DetailsTab
              mode="create"
              value={formData.details}
              onChange={(val) => handleSectionChange('details', val)}
            />
          )}
          {activeTab === 'brandPersonality' && (
            <BrandPersonality
              mode="create"
              value={formData.brandPersonality}
              onChange={(val) => handleSectionChange('brandPersonality', val)}
            />
          )}
          {activeTab === 'brandKit' && (
            <BrandKit
              mode="create"
              value={formData.brandKit}
              onChange={(val) => handleSectionChange('brandKit', val)}
            />
          )}
          {activeTab === 'socials' && (
            <Socials
              mode="create"
              value={formData.socials}
              onChange={(val) => handleSectionChange('socials', val)}
            />
          )}
          {activeTab === 'customerBase' && (
            <CustomerBase
              mode="create"
              value={formData.customerBase}
              onChange={(val) => handleSectionChange('customerBase', val)}
            />
          )}
          {activeTab === 'offersBenefits' && (
            <OffersBenefits
              mode="create"
              value={formData.offersBenefits}
              onChange={(val) => handleSectionChange('offersBenefits', val)}
            />
          )}
          {activeTab === 'competitors' && (
            <Competitors
              mode="create"
              value={formData.competitors}
              onChange={(val) => handleSectionChange('competitors', val)}
            />
          )}
          {activeTab === 'integration' && (
            <Integration
              mode="create"
              value={formData.integration}
              onChange={(val) => handleSectionChange('integration', val)}
            />
          )}
        </div>
      </form>
    </div>
  );
}